// extracted by mini-css-extract-plugin
export default {"confirmButton":"confirm-button__confirm-button__ff4I3","cogIcon":"confirm-button__cog-icon__n_z1C"};